const LEGACY_POLICY_STATUS_FIELDS = [
  'receipts',
  'receiptAgentStatus',
  'managerReviewStatus',
]

export function normalizeSavedTransactionColumnFields(
  savedFields: string[],
  availableFields: string[],
): string[] {
  const availableFieldSet = new Set(availableFields)
  const availableLegacyFields = LEGACY_POLICY_STATUS_FIELDS.filter((field) =>
    availableFieldSet.has(field),
  )
  const policyStatusAvailable = availableFieldSet.has('policyStatus')
  const normalizedFields: string[] = []

  const appendUnique = (field: string): void => {
    if (!normalizedFields.includes(field)) normalizedFields.push(field)
  }

  savedFields.forEach((field) => {
    if (policyStatusAvailable && LEGACY_POLICY_STATUS_FIELDS.includes(field)) {
      appendUnique('policyStatus')
      return
    }

    if (
      field === 'policyStatus' &&
      !policyStatusAvailable &&
      availableLegacyFields.length > 0
    ) {
      availableLegacyFields.forEach(appendUnique)
      return
    }

    appendUnique(field)
  })

  return normalizedFields
}
